<script setup>
defineProps({
  size: { type: [Number, String], default: 24 }
})
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" aria-hidden="true">
    <defs>
      <radialGradient :id="`coinFace-${$.uid}`" cx="0.4" cy="0.35" r="0.7">
        <stop offset="0%" stop-color="#F5DC97"/>
        <stop offset="60%" stop-color="#E5C76B"/>
        <stop offset="100%" stop-color="#8C6E2A"/>
      </radialGradient>
    </defs>
    <circle cx="16" cy="16" r="14" :fill="`url(#coinFace-${$.uid})`" stroke="#8C6E2A" stroke-width="1"/>
    <circle cx="16" cy="16" r="11" fill="none" stroke="#8C6E2A" stroke-width="0.4" opacity="0.6"/>
    <!-- E-mark for Evoluxu -->
    <path d="M11.5 9 L20.5 9 L20.5 12 L14.5 12 L14.5 14.5 L19.5 14.5 L19.5 17.5 L14.5 17.5 L14.5 20 L20.5 20 L20.5 23 L11.5 23 Z"
          fill="#0B0A08" opacity="0.85"/>
  </svg>
</template>
